<!-- Side Structure -->
<template>
  <div class="sidebar" :class="sidebarSelectedFilter.class">
    <vue-perfect-scrollbar class="scroll-area" :settings="settings">
      <div class="transparent navigation asdfasdfasdfqwer">
        <v-list>
          <app-logo></app-logo>
          <user-block></user-block>

          <template v-for="(item, key) in menus">
            <div :key="item.path">
              <template>
                <v-list-group :ripple="false" class="not-submenu" :key="item.path" append-icon="" no-action v-model="item.active">
                  <v-list-item slot="activator" :ripple="false">
                    <v-list-item-content>
                      <v-list-item-title>
                        <router-link v-if="item && item.path" :to="item.path">
                          <i class="mr-3 zmdi" :class="item.action"></i>
                          <span>{{ item.title }}</span>
                        </router-link>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </template>
            </div>
          </template>
        </v-list>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import UserBlock from './UserBlock'
import { textTruncate, getCurrentAppLayout } from 'Helpers/helpers'
import { mapGetters } from 'vuex'
import AppLogo from 'Components/AppLogo/AppLogo'

export default {
  data() {
    return {
      settings: {
        maxScrollbarLength: 160
      }
    }
  },
  components: {
    UserBlock,
    AppLogo
  },
  computed: {
    ...mapGetters(['sidebarSelectedFilter']),
    menus() {
      return this.$store.getters.menus[localStorage.getItem('type')]
    }
  },
  methods: {
    textTruncate(text) {
      return textTruncate(text, 18)
    },
    getCurrentAppLayoutHandler() {
      return getCurrentAppLayout(this.$router)
    }
  }
}
</script>
<style scoped>
.v-list-item.theme--light {
  margin-right: 4px;
}
.v-list-item__title a {
  padding-right: 7px;
}
.v-navigation-drawer__content .site-logo img,
.v-navigation-drawer__content .site-logo a {
  height: auto !important;
  width: auto !important;
  max-width: 140px !important;
  margin: auto !important;
  display: block !important;
  float: none !important;
}
.v-navigation-drawer__content .site-logo {
  background: #f4f7fa;
  display: none !important;
}
.v-navigation-drawer .navigation .v-list .v-list-group .v-list-group__header .v-list-item,
.v-navigation-drawer .navigation .v-list .v-list-group .v-list-group__header .v-list-item__title {
  padding-left: 8px;
}
</style>
